import React from 'react';
import styled from 'styled-components';
import { Badge, Button, Modal, Notice, Text } from '@companycam/slab-web';
import PromoModalVideoPlayer from 'components/shared/PromoModalVideoPlayer';
import { translate } from 'javascripts/translations/i18n';

const StyledBadge = styled(Badge)`
  width: fit-content;
`;

const TitleContainer = styled.div`
  display: inline-block;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: var(--cc_size_spacing_m);
`;

const ButtonContainer = styled.div`
  background-color: var(--cc_color_background_2);
  display: flex;
  gap: var(--cc_size_spacing_m);
  justify-content: flex-end;
  padding: var(--cc_size_spacing_m) var(--cc_size_spacing_xl);
  border-radius: var(--cc_size_border_radius_l);
`;

const ContentContainer = styled.div`
  padding: var(--cc_size_spacing_xl) var(--cc_size_spacing_xxl);
  display: flex;
  flex-direction: column;
  gap: var(--cc_size_spacing_s);
`;

const FeatureListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--cc_size_spacing_m);
`;

const FeatureContainer = styled.div`
  display: flex;
  gap: var(--cc_size_spacing_m);
  align-items: center;
`;

const FeatureIcon = styled.i`
  color: var(--cc_color_text_nonessential);
`;

const UpgradeNotice = styled(Notice)`
  margin-top: var(--cc_size_spacing_xl);
`;

const PromoModal = ({
  onRequestClose,
  videoUrl,
  titleText,
  features,
  upgradeNoticeText,
  onClickUpgrade,
  isAdmin,
}: {
  onRequestClose: () => void;
  videoUrl: string;
  titleText: string;
  features: string[];
  upgradeNoticeText: string;
  onClickUpgrade: () => void;
  isAdmin: boolean;
}) => {
  return (
    <Modal
      isOpen
      size="small"
      bodyStyle={{ padding: 0 }}
      onClose={onRequestClose}
      title=""
      headerComponent={null}
      footerComponent={
        <ButtonContainer>
          <Button color="subtle" onClick={onRequestClose}>
            {translate('common.notNow')}
          </Button>
          <Button color="primary" onClick={onClickUpgrade}>
            {translate('common.upgrade')}
          </Button>
        </ButtonContainer>
      }
    >
      <>
        <PromoModalVideoPlayer youtubeSrc={videoUrl} />
        <ContentContainer>
          <StyledBadge color="upgrade" iconName="lightning-bolt-circle">
            {translate('common.upgrade')}
          </StyledBadge>
          <TitleContainer>
            <Text family="heading" weight="800" as="h1" size="xxxl">
              {titleText}
            </Text>
          </TitleContainer>
          <FeatureListContainer>
            {features.map((feature) => (
              <FeatureContainer key={feature}>
                <FeatureIcon className="mdi mdi-check" />
                <Text as="p" size="m" ccMargin="none">
                  {feature}
                </Text>
              </FeatureContainer>
            ))}
          </FeatureListContainer>
          {!isAdmin ? (
            <UpgradeNotice color="info">
              <Text as="p" size="xs">
                {upgradeNoticeText}
              </Text>
            </UpgradeNotice>
          ) : null}
        </ContentContainer>
      </>
    </Modal>
  );
};

export default PromoModal;
